import React, { forwardRef } from 'react'
import { Center, Grid, Text, Checkbox, CheckboxGroup } from '@chakra-ui/react'

import { useValueAs } from './utils'

export const SelectMultiple = forwardRef(
  (
    {
      value,
      onChange,
      valueAs,
      isLoading,
      isLoadingLabel = 'A carrgar...',
      isInvalid,
      isRequired,
      isReadOnly,
      isDisabled,
      children,
      ...props
    },
    ref
  ) => {
    const transform = useValueAs({ value, onChange, valueAs, isArray: true, nullValue: [] })
    const childrenProps = { isInvalid, isReadOnly }

    return (
      <CheckboxGroup {...props} value={transform.value} onChange={transform.onChange}>
        <Grid flex={1} position='relative' templateColumns='1fr 1fr'>
          {isLoading && (
            <Center
              position='absolute'
              top={0}
              left={0}
              width='100%'
              height='100%'
              zIndex={999}
              cursor='not-allowed'
              opacity={0.4}>
              <Text>{isLoadingLabel}</Text>
            </Center>
          )}
          {React.Children.map(children, ({ props }) => (
            <Checkbox
              {...props}
              {...childrenProps}
              alignItems='start'
              isDisabled={isLoading || isDisabled}
              value={`${props.value}`}
            />
          ))}
        </Grid>
      </CheckboxGroup>
    )
  }
)

export default SelectMultiple
